/** Default product measurement units (Semantic UI dropdown: key / value / text). */
export const DEFAULT_PRODUCT_UNIT_LABELS: string[] = ['грамм', 'кг', 'мл', 'литр', 'ширхэг'];

export interface ProductUnitDropdownOption {
    key: string;
    value: string;
    text: string;
}

export function createDefaultProductUnitDropdownOptions(): ProductUnitDropdownOption[] {
    return DEFAULT_PRODUCT_UNIT_LABELS.map((unit) => ({
        key: unit,
        value: unit,
        text: unit,
    }));
}

export function isStandardProductUnit(unit: string | null | undefined): boolean {
    if (unit == null || unit === '') return false;
    return DEFAULT_PRODUCT_UNIT_LABELS.indexOf(unit) !== -1;
}
